import { BOM } from "@/types/general";
import type { History } from "history";

export const copyBOM = (bom: BOM.Root, history: History) => {
    history.push(
        `/dashboard/bill-of-materials/new`,
        { bom: bom }
    );
};